<template>
    <div class="canvas-element-preview">


        <div class="row">
            <div class="col-md-8">
                <div class="frame-wrapper">
                    <template v-if="element?.data?.type === 'embed'">
                        <div v-html="element?.data?.url"></div>
                    </template>
                    <file-preview-auto-detect :files="[element?.preview_file, element?.data?.file]"
                                              :fallback-url="element?.preview_url ?? 'https://via.placeholder.com/240x240?text=PREVIEW'"/>
                </div>
            </div>
            <div class="col-md-4">
                <markdown-text v-if="element?.data?.description"
                               :content="element?.data?.description" />
                <div v-if="element?.data?.type === 'link' && element?.data?.url"
                     class="mb-3">
                    <strong>External Link: </strong>
                    <a target="_blank" :href="element?.data?.url">
                        {{ utils.ellipsis(element?.data?.url) }}
                    </a>
                </div>
                <template v-if="element?.data?.teacher_instructions">
                    <h5>Instructions</h5>
                    <markdown-text :content="element.data.teacher_instructions" />
                </template>

                <a v-if="element?.data?.type !== 'embed' && element?.data?.file"
                   @click="mixpanel.track('CANVAS_ELEMENT/DOWNLOAD', {element: element.name})"
                   :href="uploads.url( element.data.file?.url )"
                   target="_blank"
                   type="button"
                   class="btn btn-success ml-auto">Download</a>

            </div>
        </div>
    </div>
</template>

<script>
import MarkdownText from "@/Components/Common/MarkdownText";
import utils from "@/mixins/utils";
import uploads from "@/mixins/uploads";
import FilePreviewAutoDetect from "@/Components/Common/FilePreviewAutoDetect";

export default {
    name: "CanvasElementPreview",
    components: {FilePreviewAutoDetect, MarkdownText},
    mixins: [utils, uploads],
    props: ['element'],

    // data(){
    //     return {
    //         mixpanel,
    //     };
    // },

    computed: {
    },

    methods: {

    },

    mounted() {
        this.mixpanel.track('CANVAS_ELEMENT/VIEW', {element: this.element.name});
    }
}
</script>

<style lang="scss" scoped>
.frame-wrapper{
    iframe{
        width: 100%;
        height: 400px;
    }
}
</style>
